import { login, logout, signup, updateProfile, sessionLogin } from '@/api/auth'

const state = {
  coverPhotoUrl: '',
  profileUrl: '',
  nickname: '',
  objectId: '',
  position: '',
  company: '',
  country: '',
  phone: '',
  email: '',
  name: '',
  isLogin: false,
  userType: '',
  username: '',
  firstName: '',
  lastName: '',
  portrait: null,
  rawUser: null,
  sessionLoginLoading: true
}

const getters = {
  coverPhotoUrl: state => state.coverPhotoUrl,
  profileUrl: state => state.profileUrl,
  nickname: state => state.nickname,
  objectId: state => state.objectId,
  position: state => state.position,
  company: state => state.company,
  country: state => state.country,
  phone: state => state.phone,
  email: state => state.email,
  name: state => state.name,
  user: state => state,
  isLogin: state => state.isLogin,
  portrait: state => state.portrait,
  rawUser: state => state.rawUser,
  sessionLoginLoading: state => state.sessionLoginLoading
}

const actions = {
  async login ({ commit, dispatch }, { username, password, isKeepLogin }) {
    const result = await login({ username, password }, isKeepLogin)
    commit('SET_AUTH_DATA', result)
    commit('SET_IS_LOGIN', true)

    /* Detail visitor tracking - start session on login/whitelist passed */
    dispatch('visitorHistory/startViewSession', null, { root: true })

    return result
  },
  async logout ({ commit }) {
    try {
      await logout()
    } catch (e) {}
    commit('SET_AUTH_DATA', {})
    commit('SET_IS_LOGIN', false)
  },
  async signup ({ commit }, payload) {
    const result = await signup(payload)
    commit('SET_AUTH_DATA', result)
    return result
  },
  async update ({ commit, state }, payload) {
    const result = await updateProfile(state.objectId, payload)
    commit('SET_AUTH_DATA', result)
    return result
  },
  // async autoLogin ({commit}) {
  //   let success = true
  //   const result = await getUserProfile().catch(() => { success = false })
  //   if (success) {
  //     commit('SET_AUTH_DATA', result)
  //     commit('SET_IS_LOGIN', true)
  //   }
  // },
  async autoLoginBySession ({ commit, dispatch }, sessionToken) {
    try {
      dispatch('setSessionLoginLoading', true)
      const result = await sessionLogin(sessionToken)
      commit('SET_AUTH_DATA', result)
      commit('SET_IS_LOGIN', true)
      return result
    // eslint-disable-next-line no-useless-catch
    } catch (error) {
      throw error
    } finally {
      dispatch('setSessionLoginLoading', false)
    }
  },
  setSessionLoginLoading ({ state, commit }, bool) {
    commit('SET_SESSION_LOGIN_LOADING', bool)
  }
}

const mutations = {
  SET_AUTH_DATA (state, userData) {
    state.coverPhotoUrl = userData.coverPhotoUrl || ''
    state.company = userData.companyDisplayName || ''
    state.position = userData.occupationCustom || ''
    state.profileUrl = userData.profileUrl || ''
    state.objectId = userData.objectId
    state.nickname = userData.nickname || ''
    state.country = userData.country || ''
    state.phone = userData.phone || ''
    state.email = userData.email || ''
    state.name = userData.name || ''
    state.username = userData.username || ''
    state.userType = userData.userType || ''
    state.firstName = userData.firstName || ''
    state.lastName = userData.lastName || ''
    state.portrait = userData.portrait || null
    state.rawUser = userData
  },
  SET_IS_LOGIN (state, bool) {
    state.isLogin = bool
  },
  SET_SESSION_LOGIN_LOADING (state, bool) {
    state.sessionLoginLoading = bool
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
}
